import { useModalContext } from '@/components/Modal/contexts/ModalContext'
import { toast } from '@conexasaude/conexa-hero'
import { useQueryClient } from '@tanstack/react-query'
import { DateTime } from 'luxon'
import { useMemo, useCallback } from 'react'
import { useRecuseReservationConsultation } from '../../../queries'
import { CancelPreScheduleConfirmationModalProps } from './CancelPreScheduleConfirmationModal.types'

export const useCancelPreScheduleConfirmationModal = ({
  data,
}: CancelPreScheduleConfirmationModalProps) => {
  const { showModal } = useModalContext()
  const queryClient = useQueryClient()

  const recuseReservationConsultation = useRecuseReservationConsultation()

  const preScheduleDate = useMemo(
    () => DateTime.fromFormat(data?.preScheduleDate, 'dd/MM/yyyy HH:mm'),
    [data?.preScheduleDate],
  )

  const preScheduleFormatted = useMemo(() => {
    return {
      date: preScheduleDate.toFormat('dd/MM/yyyy'),
      time: preScheduleDate.toFormat('HH:mm'),
    }
  }, [preScheduleDate])

  const handlePrimaryAction = useCallback(async () => {
    try {
      await recuseReservationConsultation.mutateAsync(data?.preScheduleId, {
        onSuccess: () => {
          showModal('FEEDBACK_REFUSE_RESERVATION', {
            title: 'Pré-agendamento cancelado',
          })

          queryClient.invalidateQueries(['reservation-consultation-list'])
        },
      })
    } catch (error) {
      const errorMessage =
        error?.response?.data?.msg || error?.response?.msg || error?.message

      toast({
        message: errorMessage,
        variant: 'error',
        autoCloseDuration: 5000,
      })
    }
  }, [
    data?.preScheduleId,
    queryClient,
    recuseReservationConsultation,
    showModal,
  ])

  return {
    data: {
      preScheduleFormatted,
    },
    loadings: {
      primaryAction: recuseReservationConsultation.isLoading,
    },
    actions: {
      handlePrimaryAction,
    },
  }
}
